module.exports = __webpack_public_path__ + "img/u1832.aace3340.png";